import { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle";
import Table from "../../../components/Table/Table";
import { TableSearch, FilterSelect } from "../../../components/Table/TableActions";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import nosearch from "../../../assets/images/no-search.svg";
import { TabContext } from "@mui/lab";
import SelectGroup from "../../../components/FormComponent/SelectGroup";

const ALL_STUDENT_GRADE = "/api/v1/grade";
const STUDENT_CLASS = "/api/v1/grade/classes";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";

const Grades = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [classRecord, setClassRecord] = useState([]);
  // const [value, setValue] = useState({});
  const [gradeData, setGradeData] = useState([]);
  const [terms, setTerms] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [currentStudentClass, setCurrentStudentClass] = useState({});
  const [selectedTerm, setSelectedTerm] = useState("");
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [value, setValue] = useState("1");

  const getStudentGrade = (params) => {
    setIsPageLoading(true);
    httprequest.get(`${ALL_STUDENT_GRADE}`, { params })
      .then((res) => {
        setIsPageLoading(false);
        setGradeData(res?.data?.data);
        setSearchResult(res?.data?.data);
      }).catch((err) => {
        setIsPageLoading(false);
        toast.error(err?.response?.data);
      });
  };

  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  // Handle Get All Classes
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  // Handle Session Change
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  // Handles the change event when a new tab is selected
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
  };

  // Find Active Term in an Current Session
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  //   const currentClass = classRecord.find(clas => clas.class.id === newValue
  //   );
  //   const params = {
  //     class_id: currentClass?.class?.id,
  //     term_id: currentClass?.terms?.[0]?.id
  //   };
  //   getStudentGrade(params);
  //   setTerms(currentClass?.terms);
  // };

  const width = useWindowSize();
  const mobile = width < 600;

  const columns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    ...(
      Array.from(
        new Set(
          searchResult?.flatMap(result => Object.keys(result?.CA_scores || {})
          )
        )
      ).map((caKey) => ({
        name: caKey,
        selector: (row) => (
          <>
            {mobile && <p className="mobile-styling">{caKey}</p>}
            {row?.CA_scores?.[caKey] ?? "--/--"}
          </>
        )
      }))
    ),
    {
      name: "Exam Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Exam Score</p>}
          {row?.exam_score || "--/--"}
        </>
      )
    },
    {
      name: "Total Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total Score</p>}
          {row?.total || "--/--"}
        </>
      )
    },
    {
      name: "Grade",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Grade</p>}
          {row?.grade || "--/--"}
        </>
      )
    }
  ];
  const testcolumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    ...(
      Array.from(
        new Set(
          searchResult?.flatMap(result => Object.keys(result?.CA_scores || {})
          )
        )
      ).map((caKey) => ({
        name: caKey,
        selector: (row) => (
          <>
            {mobile && <p className="mobile-styling">{caKey}</p>}
            {row?.CA_scores?.[caKey] ?? "--/--"}
          </>
        )
      }))
    ),
    {
      name: "Total CA",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total CA</p>}
          {row?.CA_total != null ? parseInt(row?.CA_total) : "--/--"}
        </>
      )
    }
  ];

  const examcolumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Exam Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Exam Score</p>}
          {row?.exam_score || "--/--"}
        </>
      )
    }
  ];

  const getStudentClass = async () => {
    try {
      setIsPageLoading(true);
      const res = await httprequest.get(`${STUDENT_CLASS}`);
      setIsPageLoading(false);
      const classData = res?.data?.data;
      setClassRecord(classData);
    } catch (err) {
      setIsPageLoading(false);
      toast.error(err?.response?.data);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      await getStudentClass();
    };
    fetchData();
  }, []);

  useEffect(() => {
    getAllSessions();
    getAllTerms();
  }, []);

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
    }
  }, [active_term_session]);

  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  useEffect(() => {
    if (classRecord.length > 0) {
      const currentClass = classRecord.find(clas => clas.is_current_class);
      setCurrentStudentClass(currentClass);
      const params = {
        class_id: currentClass?.class?.id,
        term_id: currentClass?.terms?.[0]?.id
      };
      getStudentGrade(params);
      // setValue(currentClass?.class?.id);
      setTerms(currentClass?.terms);
    }
  }, [classRecord]);

  const handleSearchGrade = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = gradeData?.filter((data) => valArray?.every(
      (word) => data?.subject?.name
        ?.toLowerCase()
        .includes(word?.toLowerCase()) ||
                                    data?.grade
                                      ?.toLowerCase()
                                      .includes(word?.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word?.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  const handleFilterByTerm = (event) => {
    const selectedTermValue = event.target.value;
    setSelectedTerm(selectedTermValue);
    const params = {
      class_id: currentStudentClass?.class?.id,
      term_id: selectedTermValue
    };
    getStudentGrade(params);
  };

  const formattedTerms = terms?.map((item) => ({ name: item?.name, value: item?.id }));

  return (
    <>
      <PageTitle
        title="Grades"
        subtitle="See all your results & grades"
      />
      <div className="page-content">
        <div className="flex gap-10 align-items-end margin-top-5 padding-left-16">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
        </div>
        <TabContext value={value}>
          <div className="tablist-container margin-bottom-14 padding-left-16">
            <Tabs
              className="overide-tablist"
              onChange={handleChange}
              aria-label="class tabs"
            >
              <Tab label="All Results" value="1" />
              <Tab label="Examination Results" value="2" />
              <Tab label="Test Results" value="3" />
            </Tabs>
          </div>
          <TabPanel value="1" className="tabpanel-overide">
            {isPageLoading ? (<PageLoader />) :
              <>
                {searchResult.length === 0 ? (
                  <NoData title="Empty Grade"
                    subtitle="No Grade added" img={nosearch}
                  />
                ) : (
                  <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                    <>
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchGrade} />
                      <FilterSelect onChange={handleFilterByTerm}
                        optionsArray={formattedTerms} selectValue={selectedTerm} selectName={formattedTerms?.name}
                        selectIcon="ei:calendar"
                      />
                    </>
                  }
                  />
                )}
              </> }
          </TabPanel>
          <TabPanel value="2" className="tabpanel-overide">
            {isPageLoading ? (<PageLoader />) :
              <>
                {searchResult.length === 0 ? (
                  <NoData title="Empty Grade"
                    subtitle="No Grade added" img={nosearch}
                  />
                ) : (
                  <Table data={searchResult} columns={examcolumns} subHeader={true} pagination subHeaderComponent={
                    <>
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchGrade} />
                      <FilterSelect onChange={handleFilterByTerm}
                        optionsArray={formattedTerms} selectValue={selectedTerm} selectName={formattedTerms?.name}
                        selectIcon="ei:calendar"
                      />
                    </>
                  }
                  />
                )}
              </> }
          </TabPanel>
          <TabPanel value="3" className="tabpanel-overide">
            {isPageLoading ? (<PageLoader />) :
              <>
                {searchResult.length === 0 ? (
                  <NoData title="Empty Grade"
                    subtitle="No Grade added" img={nosearch}
                  />
                ) : (
                  <Table data={searchResult} columns={testcolumns} subHeader={true} pagination subHeaderComponent={
                    <>
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchGrade} />
                      <FilterSelect onChange={handleFilterByTerm}
                        optionsArray={formattedTerms} selectValue={selectedTerm} selectName={formattedTerms?.name}
                        selectIcon="ei:calendar"
                      />
                    </>
                  }
                  />
                )}
              </> }
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

export default Grades;
